import { supabase } from "@/integrations/supabase/client";

type FrontChatIdentityResponse = {
  userHash?: unknown;
};

export function normalizeFrontChatEmail(email?: string | null): string | null {
  const normalized = email?.trim().toLowerCase();
  return normalized || null;
}

export async function getFrontChatUserHash({ email }: { email: string }): Promise<string | null> {
  const normalizedEmail = normalizeFrontChatEmail(email);
  if (!normalizedEmail) {
    return null;
  }

  const { data, error } = await supabase.functions.invoke<FrontChatIdentityResponse>("front-chat-identity", {
    body: { email: normalizedEmail },
  });

  if (error) {
    return null;
  }

  return typeof data?.userHash === "string" && data.userHash.trim() ? data.userHash.trim() : null;
}
